import React from "react";

export const OrdersReceipt = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="78"
      height="107"
      viewBox="0 0 78 107"
      fill="none"
    >
      <path
        d="M70.0055 3.91584L67.7349 1.66439C67.3136 1.23913 66.7405 1 66.1428 1C65.5451 1 64.9721 1.23913 64.5508 1.66439L62.3063 3.91584C61.885 4.3411 61.312 4.58023 60.7143 4.58023C60.1166 4.58023 59.5436 4.3411 59.1222 3.91584L56.8777 1.66439C56.4564 1.23913 55.8834 1 55.2857 1C54.688 1 54.115 1.23913 53.6937 1.66439L51.4492 3.91584C51.0278 4.3411 50.4548 4.58023 49.8571 4.58023C49.2594 4.58023 48.6864 4.3411 48.2651 3.91584L46.0206 1.66439C45.5993 1.23913 45.0263 1 44.4286 1C43.8309 1 43.2579 1.23913 42.8365 1.66439L40.592 3.91584C40.1707 4.3411 39.5977 4.58023 39 4.58023C38.4023 4.58023 37.8293 4.3411 37.408 3.91584L35.1635 1.66439C34.7421 1.23913 34.1691 1 33.5714 1C32.9737 1 32.4007 1.23913 31.9794 1.66439L29.7349 3.91584C29.3136 4.3411 28.7406 4.58023 28.1429 4.58023C27.5452 4.58023 26.9722 4.3411 26.5508 3.91584L24.3063 1.66439C23.885 1.23913 23.312 1 22.7143 1C22.1166 1 21.5436 1.23913 21.1223 1.66439L18.8778 3.91584C18.4564 4.3411 17.8834 4.58023 17.2857 4.58023C16.688 4.58023 16.115 4.3411 15.6937 3.91584L13.4492 1.66439C13.0279 1.23913 12.4549 1 11.8572 1C11.2595 1 10.6864 1.23913 10.2651 1.66439L8.02062 3.91584C7.5993 4.3411 7.02629 4.58023 6.42859 4.58023C5.83089 4.58023 5.25788 4.3411 4.83656 3.91584V3.91584C4.19447 3.26773 3.22557 3.07315 2.38424 3.42336C1.54291 3.77356 0.996007 4.59909 1.00002 5.51279V101.487C0.996007 102.401 1.54291 103.226 2.38424 103.577C3.22557 103.927 4.19447 103.732 4.83656 103.084V103.084C5.25788 102.659 5.83089 102.42 6.42859 102.42C7.02629 102.42 7.5993 102.659 8.02062 103.084L10.2651 105.336C10.6864 105.761 11.2595 106 11.8572 106C12.4549 106 13.0279 105.761 13.4492 105.336L15.6937 103.084C16.115 102.659 16.688 102.42 17.2857 102.42C17.8834 102.42 18.4564 102.659 18.8778 103.084L21.1223 105.336C21.5436 105.761 22.1166 106 22.7143 106C23.312 106 23.885 105.761 24.3063 105.336L26.5508 103.084C26.9722 102.659 27.5452 102.42 28.1429 102.42C28.7406 102.42 29.3136 102.659 29.7349 103.084L31.9794 105.336C32.4007 105.761 32.9737 106 33.5714 106C34.1691 106 34.7421 105.761 35.1635 105.336L37.408 103.084C37.8293 102.659 38.4023 102.42 39 102.42C39.5977 102.42 40.1707 102.659 40.592 103.084L42.8365 105.336C43.2579 105.761 43.8309 106 44.4286 106C45.0263 106 45.5993 105.761 46.0206 105.336L48.2651 103.084C48.6864 102.659 49.2594 102.42 49.8571 102.42C50.4548 102.42 51.0278 102.659 51.4492 103.084L53.6937 105.336C54.115 105.761 54.688 106 55.2857 106C55.8834 106 56.4564 105.761 56.8777 105.336L59.1222 103.084C59.5436 102.659 60.1166 102.42 60.7143 102.42C61.312 102.42 61.885 102.659 62.3063 103.084L64.5508 105.336C64.9721 105.761 65.5451 106 66.1428 106C66.7405 106 67.3136 105.761 67.7349 105.336L69.9794 103.084C70.4007 102.659 70.9737 102.42 71.5714 102.42C72.1691 102.42 72.7421 102.659 73.1634 103.084V103.084C73.8055 103.732 74.7744 103.927 75.6158 103.577C76.4571 103.226 77.004 102.401 77 101.487V5.51279C77.004 4.59909 76.4571 3.77356 75.6158 3.42336C74.7744 3.07315 73.8055 3.26773 73.1634 3.91584V3.91584C72.2888 4.78427 70.8801 4.78427 70.0055 3.91584Z"
        stroke="black"
        strokeWidth="0.6"
      />
      <path
        d="M44.7235 28H16.2765C13.3624 28 11 25.9853 11 23.5C11 21.0147 13.3624 19 16.2765 19H44.7235C47.6376 19 50 21.0147 50 23.5C50 25.9853 47.6376 28 44.7235 28Z"
        fill="black"
        stroke="black"
      />
      <rect
        x="8.3"
        y="40.3"
        width="60.4"
        height="7.4"
        rx="3.7"
        stroke="black"
        strokeWidth="0.6"
      />
      <rect
        x="8.3"
        y="56.3"
        width="53.4"
        height="7.4"
        rx="3.7"
        stroke="black"
        strokeWidth="0.6"
      />
      <rect
        x="8.3"
        y="72.3"
        width="26.4"
        height="7.4"
        rx="3.7"
        stroke="black"
        strokeWidth="0.6"
      />
    </svg>
  );
};
